import React from 'react';

import { WEBSITE_ANALYTICS } from '../../../../theme/tokens';
import { HubGlyph } from '../../../website/components/HubGlyph';
import { ShareGlyph, type ShareGlyphName } from './ShareGlyph';
import { Disc } from './GlyphBadge.styles';

/** The glyphs' sweep: the hub glyphs' violet, so a picture matches the tab's purple bars. */
const GLYPH_INK = {
  inkFrom: WEBSITE_ANALYTICS.inkFrom,
  inkMid: WEBSITE_ANALYTICS.inkMid,
  inkTo: WEBSITE_ANALYTICS.inkTo,
};

/** A Website-tab glyph on its dim disc, painted with the violet sweep (a tile's picture, a section's mark). */
export const GlyphBadge = ({ name }: { name: ShareGlyphName }): React.ReactElement => (
  <Disc aria-hidden="true">
    <HubGlyph ink={GLYPH_INK} span={24}>
      {(ink) => <ShareGlyph name={name} paint={ink} />}
    </HubGlyph>
  </Disc>
);

export default GlyphBadge;
